import React from 'react';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import { Title, IconTitle, Fondou, BodyText, RowIcon, TextCourse } from './style';

export default function Cardl({
  title = '',
  description = '',
  Icon = null,
  num = 0,
  primaryColor = '',
  secondaryColor = '',
}) {
  return (
    <Paper elevation={0}>
      <Grid container>
        <Grid item xs={8}>
          <Title>{title}</Title>
        </Grid>
        <Grid item xs={4} container direction="row" justifyContent="center">
          <IconTitle>
            {Icon ? (
              <Fondou color={secondaryColor}>
                <Icon sx={{ color: `${primaryColor}`, fontSize: 30 }} />
              </Fondou>
            ) : null}
          </IconTitle>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <BodyText>{description}</BodyText>
        </Grid>
      </Grid>
      <Grid container alignItems="center">
        <Grid item xs={6}>
          <RowIcon>
            <ArrowCircleRightOutlinedIcon sx={{ color: `${primaryColor}`, fontSize: 30 }} />
          </RowIcon>
        </Grid>
        <Grid item xs={6}>
          <TextCourse>{num} Cursos</TextCourse>
        </Grid>
      </Grid>
    </Paper>
  );
}
